import { render } from "./AppCard.vue?vue&type=template&id=5e0ecef0&scoped=true"
import script from "./AppCard.vue?vue&type=script&lang=ts"
export * from "./AppCard.vue?vue&type=script&lang=ts"

import "./AppCard.vue?vue&type=style&index=0&id=5e0ecef0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e0ecef0"

export default script